import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { addDays, isToday, parseISO, isEqual } from 'date-fns';
import classNames from 'classnames';

import Pill from 'components/Pill';
import { SvgArrow } from 'components/Svgs';
import { DropdownPropTypes } from 'components/Dropdown';
import Message from 'components/Message';
import { isTodayTimezone } from 'helpers/intl-fns';

import messages from './DateControls.messages';
import './DateControls.scss';

const DateControlsStepper = class extends Component {
  handleIncrementDay = this.adjustDate.bind(this, 1);

  handleDecrementDay = this.adjustDate.bind(this, -1);

  static propTypes = {
    date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    setDate: PropTypes.func,
    hasError: PropTypes.bool,
    timeZone: PropTypes.string,
    ...DropdownPropTypes,
  };

  renderSelectedDay = date => {
    date = date instanceof Date ? date : parseISO(date);
    if (isToday(date)) {
      return <Message message={messages.today} values={{ date }} />;
    }
    return <Message format="medium-w-dow-no-year" value={date} />;
  };

  handleClick = e => {
    const { toggleMenu } = this.props;

    if (e.target === e.currentTarget) {
      e.stopPropagation();
      toggleMenu(e);
    }
  };

  renderAsActive = () => {
    const { date, defaultDate, timeZone } = this.props;

    return !isTodayTimezone(date, timeZone) && !isEqual(date, defaultDate);
  };

  svgArrowTheme = () => {
    const { disabled } = this.props;
    if (disabled) {
      return 'disabled';
    }
    if (this.renderAsActive()) {
      return 'brand';
    }
    return 'dark';
  };

  adjustDate(amount, event) {
    event.stopPropagation();
    const { date, setDate, closeMenu } = this.props;
    const nextDate = addDays(date, amount);
    setDate(nextDate);
    closeMenu();
  }

  render() {
    const { date, isOpen, toggleMenu, disabled, fullWidth, hasError } = this.props;
    const pillClassNames = classNames('', {
      'date-controls--date-picker-open': isOpen,
      'date-controls--full-width': fullWidth,
    });

    return (
      <Pill
        className={pillClassNames}
        theme={hasError ? 'warn' : 'light'}
        onClick={toggleMenu}
        disabled={disabled}
        active={this.renderAsActive()}>
        <button
          className="date-controls__selected-date-short"
          type="button"
          onClick={this.handleClick}
          disabled={disabled}
          data-cypress="date-controls-current-day">
          {this.renderSelectedDay(date)}
        </button>
        <button
          className="date-controls__icon-wrap"
          onClick={this.handleDecrementDay}
          type="button"
          disabled={disabled}
          data-cypress="date-controls-previous-day">
          <SvgArrow className="date-controls__previous-day" direction="left" theme={this.svgArrowTheme()} />
        </button>
        <button
          className="date-controls__icon-wrap"
          onClick={this.handleIncrementDay}
          type="button"
          disabled={disabled}
          data-cypress="date-controls-next-day">
          <SvgArrow className="date-controls__next-day" direction="right" theme={this.svgArrowTheme()} />
        </button>
      </Pill>
    );
  }
};

export default DateControlsStepper;
